import { createStore } from 'vuex';
import { DEFAULT_HELP } from '@/constants/tiptype';

import user from './modules/user';
import device from './modules/device';

// 创建一个新的 store 实例
const store = createStore({
	state() {
		return {
			commonVisible: false,
			tipType: DEFAULT_HELP, // 对应打开的提示
		};
	},
	modules: {
		user,
		device,
	},
	mutations: {
		toggleCommonVisible(state, visible) {
			state.commonVisible = visible;
		},
		setTipType(state, type) {
			state.tipType = type || DEFAULT_HELP;
		},
	},
});

export default store;
